import { MutableRefObject, useEffect, useState } from "react";

interface IAudioPlayer {
  audioRef: MutableRefObject<HTMLAudioElement>;
  animationRef: MutableRefObject<number>;
}

const useAudioPlayer = ({ audioRef, animationRef }: IAudioPlayer) => {
  const [canShowDetails, setCanShowDetails] = useState(false);
  // const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [mute, setMute] = useState(false);
  const [playing, setPlaying] = useState(false);

  function whilePlaying() {
    setCurrentTime(audioRef.current?.currentTime);
    animationRef.current = requestAnimationFrame(whilePlaying);
  }

  const handlePlay = () => {
    setPlaying(true);
    audioRef.current.play();
    animationRef.current = requestAnimationFrame(whilePlaying);
  };

  const handlePause = () => {
    setPlaying(false);
    audioRef.current.pause();
    cancelAnimationFrame(animationRef.current);
  };

  const handleSliderChange = (value: number) => {
    // handlePause();
    setCurrentTime(value);
    audioRef.current.currentTime = value;
  };

  const handleMute = () => {
    setMute(true);
    audioRef.current.muted = true;
  };

  const handleUnmute = () => {
    setMute(false);
    audioRef.current.muted = false;
  };

  useEffect(() => {
    const audioEnded = () => {
      audioRef.current.currentTime = 0;
      setCurrentTime(0);
      setPlaying(false);
    };
    const loadedMetaData = () => {
      // const getDuration = () => {
      //   audioRef.current.currentTime = 0;
      //   audioRef?.current?.removeEventListener("timeupdate", getDuration);
      //   setDuration(Math.floor(audioRef?.current?.duration));
      // };
      // setCurrentTime(Math.floor(audioRef?.current?.currentTime));
      // if (audioRef?.current?.duration === Infinity) {
      //   audioRef.current.currentTime = 1e101;
      //   audioRef?.current?.addEventListener("timeupdate", getDuration);
      // } else setDuration(Math.floor(audioRef?.current?.duration));

      setCanShowDetails(true);
    };

    audioRef.current?.addEventListener("loadedmetadata", loadedMetaData);
    audioRef.current?.addEventListener("ended", audioEnded);

    return () => {
      cancelAnimationFrame(animationRef.current);
      audioRef?.current?.removeEventListener("loadedmetadata", loadedMetaData);
      // eslint-disable-next-line react-hooks/exhaustive-deps
      audioRef?.current?.removeEventListener("ended", audioEnded);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const duration = audioRef.current?.duration;
  return {
    canShowDetails,
    playing,
    handlePause,
    handlePlay,
    currentTime,
    duration,
    mute,
    handleMute,
    handleUnmute,
    handleSliderChange,
  };
};

export default useAudioPlayer;
